module.exports = __webpack_public_path__ + "static/bluebanana-MONEI-6951e463c61ba72c99769d765cf2df98.png";